import type {
  BreadcrumbListStructuredData,
  ListItemStructuredData,
} from '@core/structured-data';
// eslint-disable-next-line @nx/enforce-module-boundaries
import type { BreadcrumbNavItem } from '@core/navigation-ui/breadcrumb';

const MAX_BREAD_CRUMB_LENGTH = 7;

export interface BreadcrumbItem {
  url: string;
  displayName: string;
  BreadcrumbTitle: {
    jss?: {
      value: string;
    };
  };
  parent?: BreadcrumbItem;
}

export function mapRouteContext(
  context: BreadcrumbItem,
  rootUrl: string
): BreadcrumbNavItem[] {
  if (!context.parent) {
    return [];
  }

  return recursiveRouteMap(context, rootUrl).reverse();
}

export function recursiveRouteMap(
  item: BreadcrumbItem,
  rootUrl: string
): BreadcrumbNavItem[] {
  const result: BreadcrumbNavItem[] = [];

  let currentItem: BreadcrumbItem | undefined = item;
  while (currentItem && result.length < MAX_BREAD_CRUMB_LENGTH) {
    result.push({
      displayName: getDisplayName(currentItem),
      url: currentItem.url,
    });

    if (isRootUrl(currentItem.url, rootUrl)) {
      return result;
    }

    currentItem = currentItem.parent;
  }

  return result;
}

export function isRootUrl(url: string, rootUrl: string): boolean {
  return url === rootUrl || url === `${rootUrl}/`;
}

export function getDisplayName(item: any): string {
  const name = item.BreadcrumbTitle?.jss?.value || item.displayName;
  return name.charAt(0).toUpperCase() + name.slice(1);
}

export const generateStructuredDataFromRoutes = (
  routes: BreadcrumbNavItem[],
  baseUrl: string
): BreadcrumbListStructuredData => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: routes.map(
    (item, index): ListItemStructuredData => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.displayName,
      item: `${baseUrl}${item.url}`,
    })
  ),
});
